

import { motion } from 'framer-motion';
import { Plug, ListChecks, ShieldCheck } from 'lucide-react';

export default function Solution() {
  const steps = [
    {
      icon: <Plug size={32} />,
      title: "CONNECT",
      description: "Connect Jira, ServiceNow, Linear, or your PM tool in 2 minutes"
    },
    {
      icon: <ListChecks size={32} />,
      title: "DEFINE",
      description: "Set what 'complete' means—no coding required"
    },
    {
      icon: <ShieldCheck size={32} />,
      title: "ENFORCE",
      description: "Ianos stops incomplete work with clear, helpful messages"
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-4xl font-bold text-primary mb-6"
          >
            A gentle checkpoint before work moves forward
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-text-muted"
          >
            Ianos doesn't police your team.
            <br className="hidden sm:block" />
            It helps them help each other.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-100 -z-10" />

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-24 h-24 bg-white border-2 border-gray-100 rounded-full flex items-center justify-center text-accent mb-6 group-hover:border-accent group-hover:shadow-lg transition-all duration-300 z-10">
                {step.icon}
              </div>
              <h3 className="text-lg font-bold text-primary mb-3 tracking-wide">{step.title}</h3>
              <p className="text-text-muted max-w-xs">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
